/**
 * CUSTOM: Bogstav-vælger på produktsiden (A–Z i et gitter).
 * Markup: snippets/custom-letter-selector.liquid · CSS: assets/custom-letter-selector.css
 *
 * Flyttet 7/10 2026 – logik uændret (kurv-test: 4 produkter × 26 bogstaver korrekte før og efter):
 * 1) Bogstav-vælgeren (tidligere inline i snippets/block-letter-dropdown.liquid)
 * 2) "Hold øvrige valgmuligheder aktive"-scriptet (tidligere inline nederst i snippets/product-template.liquid)
 * Data (produktets option-navne) læses fra markup i stedet for Liquid.
 *
 * CUSTOM 27/10 2026: det valgte bogstav skrives i adresselinjen som ?variant= (som Motion gør for størrelser),
 * så fx Ønskeskyen får bogstavet med. Springes over for produkter med data-single-url (én URL udadtil).
 */

function customLetterUpdateUrl(variantId) {
  if (!variantId || !window.history || !window.history.replaceState) return;
  if (document.querySelector('.product-section[data-single-url]')) return;
  try {
    const url = new URL(window.location.href);
    url.searchParams.set('variant', String(variantId));
    window.history.replaceState(window.history.state, '', url.toString());
  } catch (e) {}
}

// 1) Bogstav-vælger
document.addEventListener('DOMContentLoaded', function() {
  const letterDropdownToggle = document.querySelector('.letter-dropdown-toggle');
  const letterDropdownContent = document.querySelector('.letter-dropdown-content');
  const letterOptions = document.querySelectorAll('.letter-option');
  const selectedLetterText = document.querySelector('.selected-letter-text');
  const letterPropertyInput = document.getElementById('selected-letter-property');
  const errorDiv = document.querySelector('.letter-dropdown-error');
  const addToCartBtn = document.querySelector('[data-add-to-cart]');
  const addToCartForm = document.querySelector('.product-single__form') || 
                       document.querySelector('form[action*="/cart/add"]');

  let selectedLetter = null;

  // Find hvilken option position bogstav er
  const productData = { options: JSON.parse(document.querySelector('[data-letter-product-options]').textContent) };
  let letterOptionPosition = null;

  if (productData && productData.options) {
    productData.options.forEach((option, index) => {
      const optionLower = option.toLowerCase();
      if (optionLower.includes('bogstav') || optionLower.includes('letter')) {
        letterOptionPosition = index;
        }
    });
  }

  // Funktion til at opdatere variant baseret på valgt bogstav
  function updateVariantByLetter(letter) {
    if (!letter || letterOptionPosition === null) return;

    const variantData = JSON.parse(document.getElementById('letter-variant-data').value);

    // Find alle andre valgte options
    const selectedOptions = [];
    const variantSelectors = document.querySelectorAll('.variant__input input:checked, .variant__select');

    // Byg options array
    productData.options.forEach((option, index) => {
      if (index === letterOptionPosition) {
        selectedOptions[index] = letter;
      } else {
        // Find værdien for andre options
        let foundValue = false;
        variantSelectors.forEach(selector => {
          const label = selector.closest('.variant-wrapper')?.querySelector('label');
          if (label && label.textContent.trim().toLowerCase().includes(option.toLowerCase())) {
            if (selector.tagName === 'SELECT') {
              selectedOptions[index] = selector.value;
            } else if (selector.checked) {
              selectedOptions[index] = selector.value;
            }
            foundValue = true;
          }
        });

        // Hvis ingen værdi fundet, brug første tilgængelige
        if (!foundValue && variantData.length > 0) {
          selectedOptions[index] = variantData[0]['option' + (index + 1)];
        }
      }
    });

    // Find matchende variant
    const matchingVariant = variantData.find(variant => {
      return selectedOptions.every((option, index) => {
        return variant['option' + (index + 1)] === option;
      });
    });

    if (matchingVariant) {
      // Opdater variant selector
      const variantSelect = document.querySelector('[data-product-select]');
      if (variantSelect) {
        variantSelect.value = matchingVariant.id;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      customLetterUpdateUrl(matchingVariant.id);
    }
  }

  // Toggle letter dropdown
  letterDropdownToggle.addEventListener('click', function() {
    const isOpen = letterDropdownContent.style.display === 'block';
    letterDropdownContent.style.display = isOpen ? 'none' : 'block';
    this.querySelector('svg').style.transform = isOpen ? 'rotate(0deg)' : 'rotate(180deg)';
  });

  // Letter selection
  letterOptions.forEach(option => {
    option.addEventListener('click', function() {
      if (this.disabled || this.dataset.available !== 'true') return;

      // Update visual state
      letterOptions.forEach(opt => {
        if (opt.dataset.available === 'true') {
          opt.style.borderColor = '#ddd';
          opt.style.background = 'white';
          opt.style.color = '#333';
        }
      });

      this.style.borderColor = '#333';
      this.style.background = '#333';
      this.style.color = 'white';

      // Update selected letter
      selectedLetter = this.dataset.letter;
      selectedLetterText.textContent = selectedLetter;
      letterPropertyInput.value = selectedLetter;

      // Close dropdown
      letterDropdownContent.style.display = 'none';
      letterDropdownToggle.querySelector('svg').style.transform = 'rotate(0deg)';

      errorDiv.style.display = 'none';

      // Opdater variant
      updateVariantByLetter(selectedLetter);
    });
  });

  // Opdater bogstav tilgængelighed når andre varianter ændres
  function updateLetterAvailability() {
    const variantData = JSON.parse(document.getElementById('letter-variant-data').value);
    const selectedOptions = [];

    // Find alle andre valgte options (undtagen bogstav)
    productData.options.forEach((option, index) => {
      if (index !== letterOptionPosition) {
        const variantSelectors = document.querySelectorAll('.variant__input input:checked, .variant__select');
        variantSelectors.forEach(selector => {
          const label = selector.closest('.variant-wrapper')?.querySelector('label');
          if (label && label.textContent.trim().toLowerCase().includes(option.toLowerCase())) {
            if (selector.tagName === 'SELECT') {
              selectedOptions[index] = selector.value;
            } else if (selector.checked) {
              selectedOptions[index] = selector.value;
            }
          }
        });
      }
    });

    // Opdater hver bogstav-knaps tilgængelighed
    letterOptions.forEach(letterBtn => {
      const letter = letterBtn.dataset.letter;
      selectedOptions[letterOptionPosition] = letter;

      // Find om denne kombination er tilgængelig
      const matchingVariant = variantData.find(variant => {
        return selectedOptions.every((option, index) => {
          if (index === letterOptionPosition) {
            return variant['option' + (index + 1)] === letter;
          } else if (selectedOptions[index]) {
            return variant['option' + (index + 1)] === selectedOptions[index];
          }
          return true;
        });
      });

      const isAvailable = matchingVariant && matchingVariant.available;

      // Opdater knap status
      letterBtn.disabled = !isAvailable;
      letterBtn.dataset.available = isAvailable ? 'true' : 'false';
      letterBtn.style.cursor = isAvailable ? 'pointer' : 'not-allowed';
      letterBtn.style.background = isAvailable ? 'white' : '#f8f8f8';
      letterBtn.style.borderColor = isAvailable ? '#ddd' : '#f0f0f0';
      letterBtn.style.color = isAvailable ? '#333' : '#ccc';

      // Vis/skjul strikethrough
      const strikethrough = letterBtn.querySelector('span');
      if (strikethrough) {
        strikethrough.style.display = isAvailable ? 'none' : 'block';
      }
    });
  }

  // Lyt efter variant ændringer
  document.addEventListener('change', function(e) {
    if (e.target.matches('.variant__input input, .variant__select')) {
      setTimeout(updateLetterAvailability, 10);
    }
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.letter-dropdown-picker')) {
      letterDropdownContent.style.display = 'none';
      letterDropdownToggle.querySelector('svg').style.transform = 'rotate(0deg)';
    }
  });

  // Validate on add to cart
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function(e) {
      if (!selectedLetter) {
        e.preventDefault();
        e.stopPropagation();
        errorDiv.style.display = 'block';
        letterDropdownToggle.focus();
        return false;
      }
    });
  }

  // Also validate on form submit
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function(e) {
      if (!selectedLetter) {
        e.preventDefault();
        errorDiv.style.display = 'block';
        letterDropdownToggle.focus();
        return false;
      }
    });
  }

  // Initial opdatering af tilgængelighed
  updateLetterAvailability();
});

// 2) Opdater varianten, når øvrige (ikke-bogstav) valgmuligheder ændres.
//    CUSTOM 11/10 2026 (F12): rører IKKE længere Motions disabled/soldout – udsolgte kombinationer forbliver deaktiverede.
(function () {
  const optionsEl = document.querySelector('[data-letter-product-options]');
  const optionNames = optionsEl ? JSON.parse(optionsEl.textContent) : [];
  const letterOptionIndex = optionNames.findIndex((name) => /bogstav|letter/i.test(name));

  document.addEventListener('DOMContentLoaded', function() {
    // Function to update variant based on all selected options
    function updateProductVariant() {
      const form = document.querySelector('[data-add-to-cart-form]');
      if (!form) return;

      // Get all selected options
      const selectedOptions = [];

      // Get letter from dropdown if exists
      const letterInput = document.getElementById('selected-letter-property');
      let letterValue = letterInput ? letterInput.value : null;

      // Get all variant option inputs
      const variantInputs = form.querySelectorAll('[name^="options["]');
      variantInputs.forEach(input => {
        if (input.checked || input.type === 'hidden') {
          selectedOptions.push(input.value);
        }
      });

      // If we have a letter selected, update the appropriate option
      if (letterValue) {
        if (letterOptionIndex !== -1) selectedOptions[letterOptionIndex] = letterValue;
      }

      // Find matching variant
      const variants = JSON.parse(document.querySelector('[data-variant-json]').textContent);
      const matchingVariant = variants.find(variant => {
        return variant.options.every((option, index) => option === selectedOptions[index]);
      });

      if (matchingVariant) {
        const productSelect = document.querySelector('[data-product-select]');
        if (productSelect) {
          productSelect.value = matchingVariant.id;
          productSelect.dispatchEvent(new Event('change'));
        }
        customLetterUpdateUrl(matchingVariant.id);
      }
    }

    // Bind variant-opdatering til ikke-bogstav-valgmuligheder (Motions tilgængelighed bevares)
    function enableNonLetterVariants() {
      // For button style variants
      document.querySelectorAll('.variant__button-label').forEach(label => {
        const wrapper = label.closest('.variant-wrapper');
        if (wrapper) {
          const labelElement = wrapper.querySelector('label');
          if (labelElement) {
            const labelText = labelElement.textContent.trim().toLowerCase();
            if (!labelText.includes('bogstav') && !labelText.includes('letter')) {
              const input = label.querySelector('input[type="radio"]');
              if (input) {
                input.onclick = function() {
                  setTimeout(updateProductVariant, 10);
                };
              }
            }
          }
        }
      });

      // For dropdown style variants
      document.querySelectorAll('.variant__select').forEach(select => {
        const wrapper = select.closest('.variant-wrapper');
        if (wrapper) {
          const labelElement = wrapper.querySelector('label');
          if (labelElement) {
            const labelText = labelElement.textContent.trim().toLowerCase();
            if (!labelText.includes('bogstav') && !labelText.includes('letter')) {
              select.onchange = function() {
                setTimeout(updateProductVariant, 10);
              };
            }
          }
        }
      });
    }

    // Run initially and set up observer
    enableNonLetterVariants();
    window.updateProductVariant = updateProductVariant;

    // Use MutationObserver instead of setInterval for better performance
    const observer = new MutationObserver(function(mutations) {
      enableNonLetterVariants();
    });

    const targetNode = document.querySelector('[data-product-blocks]');
    if (targetNode) {
      observer.observe(targetNode, { 
        childList: true, 
        subtree: true, 
        attributes: true,
        attributeFilter: ['class', 'disabled']
      });
    }
  });
})();
